import { useProductExtras } from '@components/Components/Providers/ProductExtrasContext';
import P, { ErrorSpan } from '@components/Components/Reusables/Typography/P'
import { capitalizeEveryWord, money, replaceStringWith, vatPricing } from '@components/config/helpers';
import Tag from '@components/Custom/Chip/Tag';
import SelectInput from '@components/Custom/Inputs/SelectInput';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { Fragment, useState } from 'react'
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const ProductExtra = (props) => {
    const {
        extras,
        is_mandatory,
        product_extras_group_title: title,
        product_extras_group_name: name,
        product_extras_group_slug: type,
        primary_product_id,
        product_extras_group_id,
        product_extras_to_group_id,
        callbacks = null,
        is_dialog = false
    } = props;

    const height = '80';
    const isMandatory = is_mandatory == 'yes';

    const { extrasSelected, setExtrasSelected, handleSelected } = useProductExtras();
    const { VATFlag, tax } = useSelector((state) => state.globalReducer);
    const router = useRouter();

    useEffect(() => {
        const defaultEvent = () => handleSelected(undefined, { extras, primary_product_id, type, isMandatory, product_extras_group_id, product_extras_to_group_id })
        if (router?.query?.extra && router?.query?.group) {
            const extra_name = capitalizeEveryWord(replaceStringWith(router.query.extra, '-', ' '));
            const foundExtra = extras.find(e => e.product_extras_product_name == extra_name);

            if (typeof foundExtra !== 'undefined') {

                handleSelected({
                    target: {
                        value: foundExtra.product_id
                    }
                }, { extras, primary_product_id, type, isMandatory, product_extras_group_id, product_extras_to_group_id })
            }
            else defaultEvent();
        }
        else defaultEvent();
    }, [])

    // useEffect(() => {
    //     if (typeof callback == null) return;
    //     else {
    //         // const images = [];
    //         // images.push(product_image);
    //         const image = Object.keys(extrasSelected).map(extra => {
    //             const productExtras = extrasSelected[extra];
    //             const extraKey = Object.keys(productExtras)[0];
    //             const foundExtra = extrasSelected[extra][extraKey];
    //             return foundExtra;
    //         })[0];

    //         if (image?.image_zoom) {
    //             // callbacks.set_thumbnail_images(images);
    //             callbacks.set_extra_image_set(image.image_zoom);
    //         }

    //         console.log({ image })


    //     }
    // }, [extrasSelected])


    return (
        <div
            className={`d-flex align-items-stretch ${is_dialog ? 'w-100' : 'mobile-w-100 w-60'}`}
            style={{
                border: '1px solid lightgrey',
                borderRadius: 4,
                overflow: 'hidden',
                height: `${height}px`
            }}
        >


            <div
                className="w-100 d-flex flex-column justify-content-between"
                style={{
                    padding: '6px 8px',
                    overflow: 'hidden'
                }}
            >
                <P color="primary" className="fw-bold mb-2" sx={{ fontSize: 14 }}>
                    {title} {isMandatory && <ErrorSpan className="fs-10">&nbsp;(Mandatory)</ErrorSpan>}
                </P>
                <SelectInput
                    size="small"
                    onChange={(e) => handleSelected(e, { extras, isMandatory, name, type, primary_product_id, product_extras_group_id, product_extras_to_group_id })}
                    value={extrasSelected?.[primary_product_id]?.[type]?.value || ''}
                    fullWidth
                >
                    {!isMandatory && (
                        <MenuItem value="None"><em>{isMandatory ? '-- None Selected --' : 'None'}</em></MenuItem>
                    )}
                    {extras.map(product_extra => (
                        <MenuItem
                            key={product_extra.product_id}
                            value={product_extra.product_id}
                        >
                            <span className="text-vertical">{product_extra.product_extras_product_name}&nbsp;
                                <Tag
                                    size="small"
                                    type={product_extra.product_price == 0 ? 'info' : 'success'}
                                    label={product_extra.product_price == 0 ? 'Included' : '+' + vatPricing(VATFlag, tax, product_extra.product_price)}
                                />
                            </span>
                        </MenuItem>
                    ))}
                </SelectInput>
            </div>
            <div
                className="position-relative"
                style={{
                    flex: `0 0 ${height}px`,
                    height: '100%'
                }}
            >
                {extrasSelected?.[primary_product_id]?.[type]?.image && <Image
                    src={extrasSelected?.[primary_product_id]?.[type]?.image}
                    alt={name}
                    fill
                    style={{ objectFit: 'cover' }}
                    sizes="(max-width: 768px) 80px, 80px"
                />}
            </div>
        </div>
    )
}

export default function ProductExtras({ product_extras, primary_product_id, callbacks, product_image, is_dialog }) {
    return (
        <div>
            <Stack spacing={1}>
                {Object.keys(product_extras).map(key => {
                    const extra = product_extras[key];
                    return (
                        <Fragment key={key}>
                            <ProductExtra
                                primary_product_id={primary_product_id}
                                product_image={product_image}
                                is_dialog={is_dialog}
                                {...extra}
                                callbacks={callbacks}
                            />
                        </Fragment>
                    );
                })}
            </Stack>
        </div>
    )
}
